define(function(require) {
    var IpsModel = require('civicsBase/ipsModel');

    return IpsModel.extend({
        urlRoot: '/delegate/civics-api/api/',
        filterURLs: {
            property: (self) =>  {
                let retURL = 'portal/autocomplete/{0}/{1}/{2}/{3}/{4}?FilterMoniker={5}'

                let propertyBindValue = '';
                if (self.conditionModelPropBindValue != undefined && self.conditionModelPropBindValue.length > 0){
                  propertyBindValue = self.encodeComponent(self.conditionModelPropBindValue);
                }

                  retURL = retURL.format(self.portletId,
                  self.conditionModel,
                  self.conditionModelPropBind,
                  self.targetFieldId,
                  propertyBindValue,
                  self.filterMoniker);

                return retURL;
            },
            formula: (self) => {
                let retURL = 'portal/autocomplete/{0}/{1}/{2}?FilterMoniker={3}'

                retURL = retURL.format(self.portletId,
                self.conditionModel,
                self.targetFieldId,
                self.filterMoniker);

                return retURL;
            }
        },
        url:function(){
            let url = this.urlRoot + this.filterURLs[this.type](this)

            return url;
        },
        parse: function(response) {
            let codeDescriptionList = [];

            if (response.documents && response.documents.length > 0) {
                      response.documents.forEach(doc => {
                          if (doc.entries) codeDescriptionList.push(doc.entries);
                      });
                  }

            //after check for duplicates.?

            codeDescriptionList.forEach( entry => {
              let strIsDefaultOption = entry['IsDefaultOption'] || 'false';
              entry['IsDefaultOption'] = JSON.parse(strIsDefaultOption.toLowerCase());
              entry['Description'] = entry['Description'] || i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
              //let's convert the boolean string here to avoid further processing on other views.
            });

            //sort it by Description.
            codeDescriptionList.sort((a, b) => (a.Description.localeCompare(b.Description)));

            response.documents = codeDescriptionList;

            return response;
        }
    });
});
